import Skeleton from "react-loading-skeleton";

import { cn } from "@/lib/helpers/cn";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";

const SKELETON_HEIGHT = 15;
const COLUMN_COUNT = 6;
const ROW_COUNT = 2;

export function MemberProfileACPSectionSkeleton() {
  return (
    <DashboardCard2
      Actions={<Skeleton height={SKELETON_HEIGHT} width={53} />}
      title={<Skeleton height={SKELETON_HEIGHT} width={76} />}
    >
      <div className="tw:flex tw:flex-col tw:gap-4">
        {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
          <div
            className={cn(
              "tw:max-lg2:grid-cols-2 tw:max-lg2:gap-y-2",
              "tw:grid tw:lg:gap-x-3 tw:lg2:grid-cols-6",
            )}
            key={`member-profile-acp-section-skeleton-row-${rowIndex}`}
          >
            {Array.from({ length: COLUMN_COUNT }).map((_, columnIndex) => (
              <div key={`member-profile-acp-section-skeleton-${rowIndex}-${columnIndex}`}>
                <Skeleton height={SKELETON_HEIGHT} width={118} />
                <Skeleton height={SKELETON_HEIGHT} width={42} />
              </div>
            ))}
          </div>
        ))}
      </div>
    </DashboardCard2>
  );
}
